{
  "SET_NEW_PASSWORD": {
    "TITLE": "Définir un nouveau mot de passe",
    "PASSWORD": {
      "LABEL": "Mot de passe",
      "PLACEHOLDER": "Mot de passe",
      "ERROR": "Le mot de passe est trop court."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Confirmer le mot de passe",
      "PLACEHOLDER": "Confirmer le mot de passe",
      "ERROR": "Les mots de passe ne correspondent pas."
    },
    "API": {
      "SUCCESS_MESSAGE": "Mot de passe modifié avec succès.",
      "ERROR_MESSAGE": "Impossible de se connecter au serveur Woot, veuillez réessayer plus tard"
    },
    "CAPTCHA": {
      "ERROR": "La vérification a expiré. Veuillez résoudre le captcha à nouveau."
    },
    "SUBMIT": "Envoyer"
  }
}
